<script setup lang="ts">
import { useI18n } from 'vue-i18n'

interface Props {
  status: string
}

defineProps<Props>()

defineOptions({
  name: 'ReferenceStatus'
})

const { t } = useI18n()
</script>

<template>
  <p class="text-xs">
    {{ t('general.status') }}:
    <slot :status>
      <span>{{ status }}</span>
    </slot>
  </p>
</template>
